import React , {useState, useEffect} from "react";
import DashboardIcon from '@mui/icons-material/Dashboard';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ErrorIcon from '@mui/icons-material/Error';
import TimerIcon from '@mui/icons-material/Timer';
import Grid from '@mui/material/Grid2';
import KpiCard from "../common/KpiCard";
import { getAuth } from "firebase/auth";
import callApi from '../common/APIClient';

function Dashboard() {
  const [docCount, setDocCount] = useState([]);
  const [avgProcessTime, setAvgProcessTime] = useState();

  useEffect(() => {
    const fetchDocCount = async () => {
      try {        
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) return;
        const token = await user.getIdToken();

        const response = await callApi({
          url: "/documents/count",
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        setDocCount(response);
        console.log('Document Count:', response);
      } catch (error) {
        console.error('Error fetching Doc Counts:', error);
      }
    };

    const fetchAvgProcessTime = async () => {
      try {
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) return;
        const token = await user.getIdToken();

        const response = await await callApi({
          url: "/documents/apt",
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        console.log(response)
        const avgProcessingTime = response.data.average_process_time 
        setAvgProcessTime(avgProcessingTime);
        console.log('Avg Processing Time:', response);
      } catch (error) {
        console.error('Error fetching Avg Processing Time:', error);
      }
    };

    fetchDocCount();
    fetchAvgProcessTime();
  }, []);

   // Map API response to KPI data (fallback to 0 if a status is missing)
   const kpiData = [
    { 
      title: "Total Documents", 
      value: docCount, 
      icon: <DashboardIcon fontSize="large" sx={{ color: "#00f5d4" }} /> 
    },
    { 
      title: "In Progress", 
      //value: (summaryData.find(item => item.status === "In Progress")?.count || 0).toString(), 
      value: 0,
      icon: <UploadFileIcon fontSize="large" sx={{ color: "#00f5d4" }} /> 
    },
    { 
      title: "Failed", 
      //value: (summaryData.find(item => item.status === "Failed")?.count || 0).toString(), 
      value: 0,
      icon: <ErrorIcon fontSize="large" sx={{ color: "red" }} /> 
    },
    { 
      title: "Avg Processing Time", 
      value: avgProcessTime, 
      icon: <TimerIcon fontSize="large" sx={{ color: "#00f5d4" }} /> 
    },
  ];

  return (
    <Grid container spacing={3} sx={{ padding: "20px" }}>
      {kpiData.map((item, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <KpiCard title={item.title} value={item.value} icon={item.icon} />
        </Grid>
      ))}      
    </Grid>
  );
}

export default Dashboard;
